import { Api } from './constants';
import { pipePromise, handleStatuses } from 'utils';

export const fetchUserProfile = pipePromise(
  (userId, options) => {
    const { token, publisherId } = options;

    return fetch(Api.FetchUserProfile(userId), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
    });
  },
  handleStatuses(),
  (response) => response.json()
);

export const createUserProfile = pipePromise(
  (userId, profile, options) => {
    const { token, publisherId } = options;

    return fetch(Api.CreateProfile, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Key: userId,
        Data: profile,
      }),
    });
  },
  handleStatuses(),
  (response) => response.text()
);

export const updateUserProfile = pipePromise(
  ({ userId, userProfileId, profile }, options) => {
    const { token, publisherId } = options;

    return fetch(Api.UpdateProfile(userProfileId), {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'x-appinapp-publisherid': publisherId,
      },
      body: JSON.stringify({
        Key: userId,
        Data: profile,
      }),
    });
  },
  handleStatuses(),
  (response) => response.json()
);
